import { css } from 'styled-components';

import theme from 'styles/token/color';

const bigDot = css`
  display: inline-block;
  content: '';
  min-width: 5px;
  height: 5px;
  margin-top: 2px;
  margin-right: 12px;
  border-radius: 100%;
  background: ${theme.color.gray800};
`;

const middleDot = css`
  display: inline-block;
  content: '';
  min-width: 3px;
  height: 3px;
  /* margin: 0 12px; */
  margin-top: -3px;
  margin-right: 8px;
  border-radius: 100%;
  background: ${theme.color.gray400};
  vertical-align: middle;
`;

const smallDot = css`
  display: inline-block;
  width: 3px;
  height: 3px;
  margin-top: -3px;
  margin-right: 10px;
  border-radius: 50%;
  background: ${theme.color.gray600};
  vertical-align: middle;
  box-sizing: border-box;
  content: '';
`;

export const dot = {
  big: bigDot,
  middle: middleDot,
  small: smallDot,
};
